<div class="wrapper p-3">
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-12">

      <router-outlet></router-outlet>
    </div>
  </div>
</div>
